module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-70eb7859.png";